import React from 'react';
import PropTypes from 'prop-types';
import getClassNameForLabel from 'utils/getClassNameForLabel';

const CalculatorButtons = ({ label, handleButtonClick }) => (
  <button
    type="button"
    className={`calculator__keypad-btn ${getClassNameForLabel(label)}`}
    onClick={() => handleButtonClick(label)}
  >
    {label}
  </button>
);

CalculatorButtons.propTypes = {
  label: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
};

export default CalculatorButtons;
